import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCards = ({ stats }) => {
  if (!stats) return null;

  const cards = [
    {
      label: 'Total Notifications',
      value: stats?.total || 0,
      icon: 'Bell',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Sent',
      value: stats?.sent || 0,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Total Recipients',
      value: stats?.totalRecipients || 0,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Success Rate',
      value: stats?.totalRecipients > 0
        ? `${Math.round((stats?.successfulSends / stats?.totalRecipients) * 100)}%`
        : '0%',
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards?.map((card, index) => (
        <div
          key={index}
          className="bg-card rounded-lg border border-border p-6 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-12 h-12 rounded-lg ${card?.bgColor} flex items-center justify-center`}>
              <Icon name={card?.icon} size={24} className={card?.color} />
            </div>
          </div>
          <h3 className="text-2xl font-bold text-foreground mb-1">{card?.value}</h3>
          <p className="text-sm text-muted-foreground">{card?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;